<template>
  <div class="goods-item">
    <div class="left">
      <a-checkbox v-model:checked="goodsItem.selected">
        {{ index + 1 }}
      </a-checkbox>
      <div class="box">
        <div class="img">
          <a-tooltip placement="top">
            <template #title>
              <img :src="goods.mainImages?.[0]?.img || defaultImage" style="width: 233px; height: 233px" />
            </template>
            <img
              :src="goods.mainImages?.[0]?.img || defaultImage"
              width="140"
              height="140"
              style="border-radius: 5px"
            />
          </a-tooltip>
          <a-button
            class="is-checked-goods"
            type="primary"
            :ghost="currentCheckedItem.id === goodsItem.id ? false : true"
            @click="clickCheckedGoods(goodsItem)"
          >
            {{ currentCheckedItem.id === goodsItem.id ? "当前选中商品" : "选中该商品" }}
          </a-button>
          <a-checkbox
            v-model:checked="goodsItem.isUpdateData"
            class="is-update-goods-data-checkbox"
            @change="updateDataInfo"
          >
            (A) {{ !goodsItem.isUpdateData ? "标记" : "" }}已修改
          </a-checkbox>
          <a-tooltip placement="bottom">
            <template #title>
              <span>删除该商品</span>
            </template>
            <a-button type="primary" danger @click="deleteGoods(goodsItem.id)">
              <template #icon>
                <DeleteOutlined />
              </template>
              (D) 删除商品
            </a-button>
          </a-tooltip>
        </div>
        <div class="info">
          <div>
            <span>商<i style="margin-left: 0.5em" />品<i style="margin-left: 0.5em" />ID: </span>
            <span>{{ goodsItem.id }}</span>
          </div>
          <div>
            <span>商品来源: </span>
            <span>{{ goodsItem.platformTypeStr }}</span>
          </div>
          <div style="margin-top: 0.5em">
            <a-button type="primary" ghost @click="copyData(goodsItem.goodsUrl, '链接')">
              复制{{ goodsItem.platformTypeStr }}链接
            </a-button>
          </div>
          <div style="margin-top: 0.5em">
            <a-button type="primary" ghost @click="copyData(goodsItem.oldTitle, '标题')">
              复制{{ goodsItem.platformTypeStr }}标题
            </a-button>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <a-tabs v-model:activeKey="activeKey" type="card">
        <a-tab-pane v-for="item in tabs" :key="item.value" :tab="item.label" />
      </a-tabs>
      <div class="content">
        <component :is="activeKey" :ref="activeKey" :categoryList="categoryList" />
      </div>
    </div>
  </div>
</template>
<script>
import { DeleteOutlined } from "@ant-design/icons-vue";
import BaseInfo from "./base_info";
import SkuInfo from "./sku_info";
import GoodsDetailImage from "./goods_detail_image";
import WhiteImage from "./white_image";
import { CopyToClipboard } from "@/utils/co_utils";
export default {
  components: { BaseInfo, GoodsDetailImage, DeleteOutlined, SkuInfo, WhiteImage },
  props: {
    goods: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    categoryList: {
      type: Array,
      default: () => [],
    },
    currentCheckedItem: {
      type: Object,
      default: () => ({}),
    },
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      goodsItem: this.goods,
      activeKey: "BaseInfo",
      defaultImage: "https://www.yiyuen.com/e/file/view/390346",
    };
  },
  methods: {
    deleteGoods(goodsId) {
      this.$emit("delete-goods", goodsId);
    },
    copyData(url, str) {
      CopyToClipboard(url);
      this.$message.success(`复制商品【${str}】成功`);
    },
    clickCheckedGoods() {
      if (this.currentCheckedItem.id === this.goodsItem.id) return;
      this.$emit("change-checked-goods", this.goodsItem);
    },
    updateDataInfo() {
      if (this.goodsItem.isUpdateData) this.$emit("change-is-update-data", this.goodsItem);
    },
    openPage(url) {
      open(url);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.goodsItem.index = this.index;
      this.$refs.BaseInfo.goodsItem = this.goodsItem;
    });
  },
  watch: {
    activeKey(value) {
      this.$nextTick(() => (this.$refs[value].goodsItem = this.goodsItem));
    },
  },
};
</script>
<style scoped lang="less">
@import "./index";
</style>
